export
{
    getEntitiesExternalCounters,
    getEntitiesExternalQueryString, getTotalExternalEntities, getPipelinedEntitiesExternal,
    getEntitiesExternalLoadingStatus, getEntitiesExternalLoadedStatus, getEntitiesExternalOupsStatus, getEntitiesExternalEmptyStatus,
    getEntitiesExternalIsDataValid,
    getEntitiesExternalImpePipelined
} from './auth/entities/external/entities-external.selectors';

export
{
    getEntitiesInternalCounters,
    getEntitiesInternalQueryString, getTotalInternalEntities, getPipelinedEntitiesInternal,
    getEntitiesInternalLoadingStatus, getEntitiesInternalLoadedStatus, getEntitiesInternalOupsStatus, getEntitiesInternalEmptyStatus,
    getEntitiesInternalIsDataValid
} from './auth/entities/internal/entities-internal.selectors';

export
{
    getSelectedEntity, getBackEntitiesFilter,
    getEntityReferents, getEntitySites, getEntityContacts, getEntityUsers,
    getPipelinedEntityUsersImpe
} from './auth/entities/global/entities-global.selectors';

export
{
    getUsersExternalCounters,
    getUsersExternalQueryString, getTotalExternalUsers, getPipelinedUsersExternal,
    getUsersExternalLoadingStatus, getUsersExternalLoadedStatus, getUsersExternalOupsStatus, getUsersExternalEmptyStatus,
    getUsersExternalIsDataValid

    // getEntityExternalUsers
} from './auth/users/external/users-external.selectors';

export
{
    getUsersInternalCounters,
    getUsersInternalQueryString, getTotalInternalUsers, getPipelinedUsersInternal,
    getUsersInternalLoadingStatus, getUsersInternalLoadedStatus, getUsersInternalOupsStatus, getUsersInternalEmptyStatus,
    getUsersInternalIsDataValid,

    getEntityInternalUsers
} from './auth/users/internal/users-internal.selectors';

export
{
    getSelectedUser, getBackUsersFilter
} from './auth/users/users.selectors';

export
{
    getEntityDetails,
    getUserDetails
} from './misc/misc.selectors';

export { BackAuthStoreModule } from './back-store.module';

export
{
    getBackBckpWidget,
    getBackBckpWidgetIsLoading,
    getBackBckpWidgetIsLoaded,
    getBackBckpWidgetIsOups,
    getBackBckpEntities,
    getBackBckpMonths,
    getBackBckpDetailIsLoading,
    getBackBckpDetailIsLoaded,
    getBackBckpDetailIsOups,
    getBackBckpRequestedMonths,
    getBackBckpMonthTotals,
    getBackBckpGrandTotal
} from './bckp/bckp.selectors';
